import React from "react";
import SeriesListPage from "../catalogue/SeriesListPage";
import { deletePodcast, getPodcastList } from "../../../services/podcasts";

const PodcastList = () => (
  <SeriesListPage
    fetchItems={() => getPodcastList().then((result) => result?.allPodcast)}
    deleteItem={deletePodcast}
    emptyIcon="ri-mic-line"
    section="podcasts"
    paths={{
      add: "/dashboard/add-podcast",
      view: (id) => `/dashboard/podcast-info/${id}`,
      episodes: (id) => `/dashboard/podcast-episode-list/${id}`,
      edit: (id) => `/dashboard/update-podcast/${id}`,
    }}
    labels={{
      title: "Podcasts",
      count: "podcasts in the catalogue",
      add: "Add Podcast",
      search: "Search podcast . . .",
      column: "Podcast",
      confirmDelete: "Are you sure you want to delete this Podcast?",
    }}
  />
);

export default PodcastList;
